import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PreloaderService } from '@core';
import { DataService } from '@core/bootstrap/data.service';
import { LocalStorage } from '@core/bootstrap/localstorage.service';
import { AlertService } from '@shared/components/alert/alert.service';
import { ConfirmationDialog } from '@shared/components/confirmation-dialog/confirmation-dialog.component';
import { LanguagePipe } from '@shared/pipes/language.pipe';
import { BsModalService } from 'ngx-bootstrap/modal';
declare var $:any;
import { Subscription } from 'rxjs';
import { OnDestroy } from '@angular/core';
@Component({
  selector: 'app-cslist',
  templateUrl: './cslist.component.html',
  styleUrls: ['./cslist.component.scss'],
  animations: [
    trigger("fadeIn", [
      state(
        "void",
        style({
          opacity: 0
        })
      ),
      transition("void <=> *", animate(1000))
    ]),
  ]
})
export class CslistComponent implements OnInit ,OnDestroy {
  branches: any 			= [];
	types: any 			  	= [];
	cData: any 			  	= [];
	lodingdatas 		  	= this.lang.transform('lang_loading');
	admin 				    = JSON.parse(this.ls.getItem('is_admin'));
	user_id					= JSON.parse(this.ls.getItem('user_id'));
	page_no:any 		  	= localStorage.getItem('M_C_S_N') 	|| 1;
	page_size:any 			= localStorage.getItem('M_C_S_S') 	|| 10;
	searchBranch 		  	= localStorage.getItem('M_C_S_B') 	|| "";
	searchType 			  	= localStorage.getItem('M_C_S_T') 	|| "";
	searchKey 			  	= localStorage.getItem('M_C_S_S_K') || "";
  constructor(public ds: DataService, public lang: LanguagePipe, public ls: LocalStorage, public fb: FormBuilder, public spinner: PreloaderService, public alert: AlertService, public dialog: MatDialog, public modalService: BsModalService) {}
	ngOnInit() {
		this.spinner.show();
		this.get_customers();
		this.get_branches();
	}
	private subscriptions = new Subscription();
	ngOnDestroy(): void {
	  this.subscriptions.unsubscribe();
	}
	public get_branches() {
		this.branches = [];
		this.subscriptions.add(
				this.ds.getActionByUrl([], 'cs/b/customers_view').subscribe(res => {
					if (res.status) {
						this.branches = res.records;
					}
				})      
			)

	}
	public loadpage(page) {
		this.page_no = page;
		this.page_size = this.page_size;
		this.get_customers();
	}
	public loadpagesize(size) {
		this.page_no = 1;
		this.page_size = size;
		this.get_customers();
	}
	public load_customers() {
		this.page_no = 1;
		this.page_size = 10;
		this.get_customers();
	}
	public get_customers() {
		localStorage.setItem('M_C_S_N', this.page_no);
		localStorage.setItem('M_C_S_S', this.page_size);
		localStorage.setItem('M_C_S_B', this.searchBranch || ''); // Customers Branch
		localStorage.setItem('M_C_S_S_K', this.searchKey || ''); // Customers Search Key
		let param = new FormData();
		param.append('searchBranch', this.searchBranch || '');
		param.append('searchBy', this.searchType || '');
		param.append('searchKey', this.searchKey || '');
		this.subscriptions.add(
			this.ds.postActionByUrl(param, 'cs/get/' + this.page_no + '/' + this.page_size).subscribe(res => {
						this.spinner.hide();
						if (res.status) {
							this.cData = res;
						} else {
							this.lodingdatas = res.error;
							this.cData = [];
						}
					}, error => {
						this.cData = [];
						this.spinner.hide();
						this.lodingdatas = (error && error.error && error.error.error) ? error.error.error : this.lang.transform('lang_internal_server_error');
					})      
			)
		
	}
	public checkAllItemsCSmers(event) {
		if (event.target.checked) {
			$(".customers .eachItemCSmers").prop("checked", true);
			$(".customers .makeback").addClass("bground");
			$(".customers .deleteIconDiv").show();
		} else {
			$(".customers .eachItemCSmers").prop("checked", false);
			$(".customers .makeback").removeClass("bground");
			$(".customers .deleteIconDiv").hide();
		}
	}
	public checkEachItemCSmers(event) {
		if (event.target.checked) {
			const val = event.target.value;
			$(".customers .removerow" + val).addClass("bground");
		} else {
			const val = event.target.value;
			$(".customers .removerow" + val).removeClass("bground");
		}
		const checkedtotal = [];
		$(".customers .eachItemCSmers:checked").each(function() {
			checkedtotal.push($(this).val());
		});
		const totalrow = [];
		$(".customers .eachItemCSmers").each(function() {
			totalrow.push($(this).val());
		});
		if (checkedtotal.length > 0) {
			$(".customers .deleteIconDiv").show();
		} else {
			$(".customers .deleteIconDiv").hide();
		}
		if (checkedtotal.length === totalrow.length) {
			$(".customers #allItemsCSmers").prop("checked", true);
		} else {
			$(".customers #allItemsCSmers").prop("checked", false);
		}
	}
	public deleteBulkDataCSmers() {
		const checkedtotal = [];
		$(".customers .eachItemCSmers:checked").each(function() {
			checkedtotal.push($(this).val());
		});
		if (checkedtotal.length > 0) {
			const dialogRef = this.dialog.open(ConfirmationDialog, {
				disableClose: true,
				width: '400px',
				data: {
					title: this.lang.transform('lang_confirmation'),
					message: this.lang.transform('lang_are_you_sure'),
				}
			});
			this.subscriptions.add(
						dialogRef.afterClosed().subscribe((confirmed: boolean) => {
							if (confirmed) {
								this.spinner.show()
								this.subscriptions.add(
										this.ds.deleteActionByUrl(checkedtotal, "cs/delete").subscribe(
											(data) => {
												this.spinner.hide()
												if (data.status) {
													this.load_customers();
													$(".customers #allItemsCSmers").prop("checked", false);
													$(".customers .deleteIconDiv").hide();
													this.ds.dialogf('', data.msg);
												} else {
													this.ds.dialogf('', data.error);
												}
											},
											(error) => {
												this.ds.dialogf('', (error && error.error && error.error.error) ? error.error.error : this.lang.transform('lang_internal_server_error'));
												this.spinner.hide()
											}
										)      
									)
;
							}
						})      
				)
;
		} else {
			this.ds.dialogf();
		}
	}
}
